import {
  getSections,
  addSection,
  addLesson,
  updateLesson,
  deleteLesson,
  reorderLessons,
} from '@/services/InstructorService/InstructorCourseManagementService';
import type { CourseSectionsService } from '../types';

export const trainerCourseSectionsService: CourseSectionsService = {
  getSections,
  addSection,
  addLesson,
  updateLesson,
  deleteLesson,
  reorderLessons,
};
